import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NativeWindowService } from '../../../core/service/native-window.service';

@Component({
  selector: 'app-hogia-id-login-failure',
  templateUrl: './hogia-id-login-failure.component.html',
  styleUrls: ['./hogia-id-login-failure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HogiaIdLoginFailureComponent {
  constructor(private readonly _nativeWindowService: NativeWindowService) {}

  retryHogiaIdLogin(): void {
    this._nativeWindowService.window.location.replace('/hogia');
  }
}
